<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>软件版本设置</span>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" class="search-form form-list" label-width="80px">
                    <el-form-item label="PCBA">
                        <el-input placeholder="请输入固件版本" v-model.trim="sw.pcba"></el-input>
                    </el-form-item>
                    <el-form-item label="整机测试">
                        <el-input placeholder="请输入固件版本" v-model.trim="sw.machine"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="setting">
                            <span>确认</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
    
</template>
<script>
export default({
    name: 'cb-sw',
    data() {
        return {
            sw: {
                pcba: '',
                machine: ''
            }
        }
    },
    created() {
        this.getFw();
    },
    methods: {
        getFw() {
            this.api.getCatBoxSw({}).then(data => {
                this.sw = data.data;
            })
        },
        setting() {
            if(this.sw) {
                this.api.setCatBoxSw(this.sw).then(data => {
                    this.$message.success('修改成功!');
                })
            }
        }
    }
})
</script>
<style lang="less" scoped>
     .sw{
        width: 200px;
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/view/product-test-tool/cat-box/sw.vue